module.exports = __webpack_public_path__ + "static/media/stranice.25ddfafb.svg";